/**
 * Handles form submission for Mailchimp newsletter subscription.
 *
 * This function is called whenever the form with the class "mailchimp-form" is submitted.
 * It sends a POST request to the WordPress admin-ajax.php URL with the form data.
 * If the response is successful, it displays a success message and resets the form.
 * If the response is an error, it displays an error message.
 *
 * @param {Event} e - The form submission event.
 */
function handleSubmit(e) {
    e.preventDefault();

    const form = e.target;
    const submitButton = form.querySelector( 'button[type="submit"]' );
    const responseDiv = document.getElementById( 'mailchimp-response' );
    const emailInput = form.querySelector( 'input[name="email"]' );
    const nonceInput = form.querySelector( 'input[name="mc_nonce"]' );

    // Disable submit button while processing
    submitButton.disabled = true;

    // Create FormData
    const formData = new FormData();
    formData.append( 'action', 'mailchimp_subscribe' );
    formData.append( 'email', emailInput.value );
    formData.append( 'mc_nonce', nonceInput.value );

    fetch( wpData.ajaxUrl, {
        method: 'POST',
        body: formData
    } )
    .then( response => response.json() )
    .then( data => {
        if ( data.success ) {
            responseDiv.innerHTML = '<div class="alert alert-success">Vielen Dank für Ihre Anmeldung!</div>';
            form.reset();
        } else {
            console.log( data );
            responseDiv.innerHTML = `<div class="alert alert-danger">${data.data}</div>`;
        }
    })
    .catch( error => {
        console.log('Error details:', error);
        responseDiv.innerHTML = '<div class="alert alert-danger">Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.</div>';
    } )
    .finally( () => {
        submitButton.disabled = false;
    } );
}

function initMailchimpForm() {
    const form = document.getElementById( 'mailchimp-form' );
    if ( form ) {
        form.addEventListener( 'submit', handleSubmit );
    }
}

document.addEventListener( 'DOMContentLoaded', initMailchimpForm );